import { type ReactElement } from 'react'
import Link from 'next/link'
import { Trans, useTranslation } from '@mc/i18n'
import { paths } from '@mc/paths'
import SubscriptionLogo from 'pages/certificates/assets/subscription-logo.svg'
import { MCCERTS_2548_SUBSCRIPTIONS_ENTRY_POINT_I18N_NAMESPACE } from './i18n'

type SubscriptionNoteProps = {
  // Lead-in copy before the Annual Pass lockup ("Save when you purchase with"
  // by default)
  leadIn?: string
  // Override for the Learn More link element (e.g. to add click tracking)
  learnMoreLink?: ReactElement
}

// Shared with mccerts-2624_v1_hub_subs_row (hub hero note) — keep this
// component and its i18n keys until BOTH experiments conclude.
// Subs-awareness line rendered under a hero CTA:
// "<leadIn> [Annual Pass lockup] Learn More"
export const SubscriptionNote = ({
  leadIn,
  learnMoreLink,
}: SubscriptionNoteProps) => {
  const { t } = useTranslation(
    MCCERTS_2548_SUBSCRIPTIONS_ENTRY_POINT_I18N_NAMESPACE,
  )

  return (
    <p className='flex flex-col items-center gap-1 lg:flex-row lg:items-center lg:gap-3 c-body-small text-c-text-tint-3'>
      <span className='flex items-center gap-2'>
        {leadIn ?? t('variant3.alsoIncludedWith')}
        <SubscriptionLogo
          role='img'
          aria-label={t('variant3.annualPassLabel')}
        />
      </span>
      <Trans
        ns={MCCERTS_2548_SUBSCRIPTIONS_ENTRY_POINT_I18N_NAMESPACE}
        i18nKey='variant3.annualSubscription'
        components={{
          learnMoreLink: learnMoreLink ?? (
            <Link
              href={paths.certificatesAnnualPass}
              className='underline text-c-text-tint-3'
            />
          ),
        }}
      />
    </p>
  )
}
